import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';
import { useCommentSlice, CommunicationMode } from '../CommentState';
import { selectCommunicationMode } from '../CommentState/selectors';
import { CustomRadioGroup, type RadioOption } from '../../../../../components/CustomRadioGroup';
import { saveUserPreferences } from '../../../../../utils/helpers';

function SendViaSection() {
  const dispatch = useDispatch();
  const { actions } = useCommentSlice();
  const communicationMode = useSelector(selectCommunicationMode);

  const handleChange = (value: string) => {
    const mode = value as CommunicationMode;
    dispatch(actions.setCommunicationMode(mode));
    // Save the preference to localStorage
    saveUserPreferences({ communicationModePreference: mode });
  };

  const options: RadioOption[] = [
    { value: 'EMAIL', label: 'Email' },
    { value: 'SLACK', label: 'Slack' }
  ];

  return (
    <div className={styles.sendViaSection}>
      <span className={styles.label}>Send via:</span>
      <CustomRadioGroup
        options={options}
        value={communicationMode}
        onChange={handleChange}
        name="communicationMode"
      />
    </div>
  );
}

export default SendViaSection;
